import type { FaireProductEntity } from "../../entity_types/product";

export const p_ywpbnhf8gf: FaireProductEntity = {
  token: "p_ywpbnhf8gf",
  type: "product",
  name: "1” Mixed Crystal Mini Peen Healing energy",
  brandToken: "b_edj9u7j4sq",
  brandName: "KayleeNYC",
  imageUrl: "https://cdn.faire.com/fastly/40003074ee11af9c724f1fb32ba61ed94d13cde01363bfdbc9f9bbfe37d2e30b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7d0fa8681551e901bcc1cebfe916bfddb75396a71ee1761ceea0bbe482325156.jpeg",
    "https://cdn.faire.com/fastly/1e853514c7ddf57ad9bc5a85956a51652d848918909e19a64a01b61988f390a0.jpeg",
    "https://cdn.faire.com/fastly/9c128e3e7697fd4a73763a6ee763d5784f5f19c208efb403d2b613b8260ea034.jpeg",
    "https://cdn.faire.com/fastly/761da2c0011562ce90f66a83a16fd8a77c6097d30dfb11ba8a0ae481ca1e22d7.jpeg",
    "https://cdn.faire.com/fastly/cf1d033b116f6c3f8a9061b5b93f3bafa8efa2ba39b601772547fd646df4b547.jpeg",
    "https://cdn.faire.com/fastly/f45e17cdb912add8004facd8afedca19e94d30bf157a34447dd1fc83f7f10ed2.png"
  ],
  priceDollars: 1.94,
  description: " 1” Mixed Crystal Mini Peen. Condition is New. You will receive 2 Rose Quartz, 2 Amethyst, 2 Aventurine, 2 Tiger Eye, 1 Howlite, 1 Orange Calcite, 1 Jade, 1 Larvikite, 2 Kambaba Jasper, 2 Bloodstone, 2 Tree Agate, 1 Unakite, 2 Dalmatian Jasper, 1 Brecciated Jasper, and 2 Kiwi Jasper. Minimum order 24 pcs.\n\nLocal pickup is available in Brooklyn, New York. \n\nStones, stone, crystal, crystals, crystals bulk, crystals wholesale, spiritual, spiritual items, meditation, metaphysical wholesale.",
  tags: [],
  msrpDollars: 3.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:11.941Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
